var map = {
	"./danger-theme.png": 16548,
	"./info-theme.png": 54465,
	"./primary-theme.png": 72754,
	"./secondary-theme.png": 53807,
	"./success-theme.png": 59301,
	"./warning-theme.png": 11252
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9924;